import React, { Component } from 'react';
import { Router, Route, browserHistory } from 'react-router';
import {FormattedHTMLMessage} from 'react-intl';
var moment = require('moment');
import 'react-dates/initialize';
import MainContainer from '../containers/MainContainer';
import CbuContainer from '../containers/CbuContainer';
import SmsContainer from '../containers/SmsContainer';
import ProductContainer from '../containers/ProductContainer';
import AddressContainer from '../containers/AddressContainer';
import PendingContainer from '../containers/PendingContainer';
import JobInfoFormContainer from '../containers/JobInfoFormContainer';
import EmailFormContainer from '../containers/EmailFormContainer';
import ServiceInfoFormContainer from '../containers/ServiceInfoFormContainer';
import PersonalInfoFormContainer from '../containers/PersonalInfoFormContainer';
import IncomesFormContainer from '../containers/IncomesFormContainer';
import UploadFormContainer from '../containers/UploadFormContainer';
import UploadDocumentsContainer from '../containers/UploadDocumentsContainer';
import AffidavitCointainer from '../containers/AffidavitContainer';
import PersonInformationContainer from '../containers/PersonInformationContainer';
import CarSimulationContainer from '../containers/CarSimulationContainer';
import EmailVerificationContainer from '../containers/EmailVerificationContainer';
import Congratulations from './Congratulations';
import Rejected from './Rejected';
import Inspected from './Inspected';
import Disapproved from './Disapproved';
import CarAsPaymentContainer from '../containers/CarAsPaymentContainer';
import CheckOutContainer from '../containers/CheckOutContainer';
import RenaperFaceContainer from '../containers/RenaperFaceContainer';
import RenaperDniContainer from '../containers/RenaperDniContainer';
import EmailPendingContainer from '../containers/EmailPendingContainer';
import ContractsContainer from '../containers/ContractsContainer';
import PaymentContainer from '../containers/PaymentContainer';
import Whatsapp from './WhatsappButton.js';
import { HotKeys } from "react-hotkeys";

const keyMap = {
    SHOW_SELLER_CODE: "shift+c"
  };

moment.locale('es');

export default class App extends Component {

    render() {
        return (
            <HotKeys keyMap={keyMap}>
            <div className="App">
                <div className="pd-content">
                    <Router history={browserHistory} >
                        <Route path="/" component={MainContainer} />
                        <Route path="/email" component={EmailVerificationContainer} />
                        <Route path="/incomes" component={IncomesFormContainer} />
                        <Route path="/job-info" component={JobInfoFormContainer} />
                        <Route path="/add-email" component={EmailFormContainer} />
                        <Route path="/personal-info" component={PersonalInfoFormContainer} />
                        <Route path="/service-info" component={ServiceInfoFormContainer} />
                        <Route path="/uploads" component={UploadFormContainer} />
                        <Route path="/upload-documents" component={UploadDocumentsContainer} />
                        <Route path="/cbu" component={CbuContainer} />
                        <Route path="/renaper-face" component={RenaperFaceContainer} />
                        <Route path="/renaper-dni" component={RenaperDniContainer} />
                        <Route path="/sms" component={SmsContainer} />
                        <Route path="/address" component={AddressContainer} />
                        <Route path="/product" component={ProductContainer} />
                        <Route path="/pending" component={PendingContainer} />
                        <Route path="/email-pending" component={EmailPendingContainer} />
                        <Route path="/affidavit" component={AffidavitCointainer} />
                        <Route path="/car-as-payment" component={CarAsPaymentContainer} />
                        <Route path="/person-information" component={PersonInformationContainer} />
                        <Route path="/car-simulation" component={CarSimulationContainer} />
                        <Route path="/checkout" component={CheckOutContainer} />
                        <Route path="/contracts" component={ContractsContainer} />
                        <Route path="/payment" component={PaymentContainer} />
                        <Route path="/congratulations" component={Congratulations} />
                        <Route path="/rejected" component={Rejected} />
                        <Route path="/inspected" component={Inspected} />
                        <Route path="/disapproved" component={Disapproved} />
                    </Router>
                </div>
                <Whatsapp
                    number={process.env.REACT_APP_PHONE_NUMBER}
                    text="Hola, tengo una consulta."
                />
                <div className={'main-padding'}></div>
                <footer>
                    <div id="footer-bottom">
                            <div className="footer_sign">
                                <FormattedHTMLMessage
                                    id="app.footer-copyright"
                                    description="Describe Copyright" />
                                    {new Date().getFullYear()}
                                <FormattedHTMLMessage
                                    id="app.footer-sign"
                                    description="Datos de la empresa" />
                            </div>
                    </div>
                </footer>
            </div>
            </HotKeys>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/